import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  // view type
  const [viewType, setViewType] = useState({ view: '' });
  useEffect(() => {
    setViewType({ view: type });
  }, [type]);
  const inpStatus = viewType.view === '' ? '_read' : '';
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {};
  const labelStyle = { width: '180px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className="_comp_detail_content_div _active">
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_base')}
            label="급여"
            labelPosition="left"
            value={addComma(data.tsal_base || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_bonus')}
            // inputRef={inpRef}
            label="상여"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.tsal_bonus || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_rbonus')}
            // inputRef={inpRef}
            label="인정상여"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.tsal_rbonus || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_stkopt')}
            // inputRef={inpRef}
            label="주식매수선택권행사이익"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.tsal_stkopt || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_esop_withdrawal')}
            // inputRef={inpRef}
            label="우리사주조합인출금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.tsal_esop_withdrawal || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_excess_exec_retire')}
            // inputRef={inpRef}
            label="임원 퇴직소득금액 한도초과"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.tsal_excess_exec_retire || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half _n_bor" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tsal_excess_invent_reward')}
            // inputRef={inpRef}
            label="직무발명 보상금(한도초과분)"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.tsal_excess_invent_reward || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
